import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation, Link } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import Header from '../components/Header';

const ModerationLayout: React.FC = () => {
    const location = useLocation();
    const { isModerator } = useContext(UserContext);

    if (!isModerator()) {
        return <Navigate to="/last" replace />;
    }

    const isActive = (path: string) => {
        return location.pathname === `/moderation${path}`;
    };

    return (
        <div className={"Page ModerationPage postsList"}>
            <Header />
            <nav className="sub-nav">
                <Link 
                    to="/moderation/facebook"
                    className={`sub-nav-item ${isActive('') || isActive('/facebook') ? 'active' : ''}`}
                >
                    Facebook
                </Link>
                <Link 
                    to="/moderation/corrections"
                    className={`sub-nav-item ${isActive('/corrections') ? 'active' : ''}`}
                >
                    Corrections
                </Link>
                <Link 
                    to="/moderation/comments"
                    className={`sub-nav-item ${isActive('/comments') ? 'active' : ''}`}
                >
                    Commentaires
                </Link>
                <Link 
                    to="/moderation/trash"
                    className={`sub-nav-item ${isActive('/trash') ? 'active' : ''}`}
                >
                    Corbeille
                </Link>
            </nav>
            <div className="moderation-content">
                <Outlet />
            </div>
        </div>
    );
};

export default ModerationLayout;
